import { Tags } from '@/core/domain/crm/EmailTags/EmailTags.types';
import { Button, Modal, Table } from 'antd';
import React, { useCallback, useState } from 'react';
import './styles.less';
import { EmailTextInput } from '@/components/_common';
import { Quill } from 'react-quill';

interface Props {
  value?: string;
  onChange?: (content: string) => void;
  tagsByType?: Tags[];
  quizId?: number;
}

function handleTags(this: { quill: Quill }, value: string) {
  if (value) {
    const cursorPosition = this.quill.getSelection()?.index ?? 0;
    this.quill.insertText(cursorPosition, value);
    this.quill.setSelection(cursorPosition, value.length);
  }
}

const EmailEditor: React.FC<Props> = ({
  value,
  onChange,
  tagsByType,
  quizId,
}) => {
  const [modalVisisble, setModalVisible] = useState(false);

  const initalConfig = useCallback(() => {
    const patternPickerItems = Array.prototype.slice.call(
      document.querySelectorAll('.ql-tags .ql-picker-item'),
    );

    patternPickerItems.forEach(
      (item) => (item.textContent = item.dataset.value),
    );

    const patternPickerLabel = document.querySelector(
      '.ql-tags .ql-picker-label',
    );

    if (patternPickerLabel) {
      patternPickerLabel.innerHTML = `Tags <span style="display: inline-block; padding-left: 20px">${patternPickerLabel.innerHTML}</span>`;
    }
  }, [tagsByType]);

  function toggleModal() {
    setModalVisible(!modalVisisble);
  }

  const listPatternValues = useCallback(() => {
    return tagsByType
      ?.map((item) => item.name)
      .filter((tag) => !(!quizId && tag === '@{questionario.link}'));
  }, [quizId, tagsByType]);

  function listPatternData() {
    if (tagsByType) {
      return tagsByType
        .map((key) => ({
          tag: key.name,
          description: key.description,
        }))
        .filter((tag) => !(!quizId && tag.tag === '@{questionario.link}'));
    }
  }

  return (
    <div>
      <Button type="link" onClick={toggleModal}>
        Sobre Tags
      </Button>

      <EmailTextInput
        initialConfig={initalConfig}
        value={value}
        onChange={onChange}
        toolbar={{
          container: [[{ tags: listPatternValues() }]],
          handlers: {
            tags: handleTags,
          },
        }}
        style={{ height: 400 }}
      />

      <Modal
        open={modalVisisble}
        onCancel={toggleModal}
        title="Informações sobre as tags de e-mail"
        width={900}
        footer={null}
      >
        <h3 style={{ margin: 0 }}>Opções de filtro</h3>
        <p>
          Nessa opção de envio você poderá filtrar os clientes por sexo,
          montadora dos seus veículos e modelo dos seus veículos.
        </p>

        <h3>Montagem do e-mail</h3>
        <p>
          Para montar o e-mail, é permitido o uso de tags que serão substituidas
          por informações do sistema.
        </p>

        <Table
          columns={[
            { key: 'tag', dataIndex: 'tag', title: 'Tag' },
            {
              key: 'description',
              dataIndex: 'description',
              title: 'Descrição',
            },
          ]}
          dataSource={listPatternData()}
          rowKey={(record) => record.description}
          pagination={false}
        />
      </Modal>
    </div>
  );
};

export default EmailEditor;
